import { render, staticRenderFns } from "./editRoleSubmit.vue?vue&type=template&id=417d0450&scoped=true&"
import script from "./editRoleSubmit.vue?vue&type=script&lang=js&"
export * from "./editRoleSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editRoleSubmit.vue?vue&type=style&index=0&id=417d0450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417d0450",
  null
  
)

export default component.exports